module.exports = __webpack_public_path__ + "img/ico_earthtemperature15-35.36c93d62.svg";